/**
 * @generated SignedSource<<be6c973991a8c547b3f4819ceb4d1242>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type GraphQLConversationThreadState = "COMPLETED" | "INTERRUPTED" | "PENDING" | "%future added value";
export type GraphQLMessageMessageRole = "AGENT" | "HUMAN" | "%future added value";
export type GraphQLMessageMessageType = "AGENT_PROCESS" | "AGENT_RESPONSE" | "ERROR_RESPONSE" | "USER_INPUT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AlertResponderConversationWithRefetch_llmConversation$data = {
  readonly id: any;
  readonly messages: ReadonlyArray<{
    readonly agentThoughtProcess: ReadonlyArray<{
      readonly subagentDescription: string | null | undefined;
      readonly subagentItems: ReadonlyArray<{
        readonly text: string | null | undefined;
        readonly thinking: string | null | undefined;
        readonly thinkingSummary: string | null | undefined;
        readonly toolUse: {
          readonly toolUse: {
            readonly id: string;
            readonly name: string;
          } | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"ChecklistToolCallResult_toolCall" | "SkillCluster_toolCall" | "ToolCallSheet_toolCall" | "V2AgentThoughtProcessRenderer_toolCall">;
        } | null | undefined;
      }> | null | undefined;
      readonly subagentOutput: string | null | undefined;
      readonly text: string | null | undefined;
      readonly thinking: string | null | undefined;
      readonly thinkingSummary: string | null | undefined;
      readonly toolUse: {
        readonly toolUse: {
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"ChecklistToolCallResult_toolCall" | "SkillCluster_toolCall" | "ToolCallSheet_toolCall" | "V2AgentThoughtProcessRenderer_toolCall">;
      } | null | undefined;
    }>;
    readonly content: string;
    readonly endedAt: any | null | undefined;
    readonly id: string;
    readonly messageRole: GraphQLMessageMessageRole;
    readonly messageType: GraphQLMessageMessageType | null | undefined;
    readonly startedAt: any;
    readonly " $fragmentSpreads": FragmentRefs<"messageWithToolReferences_formattedMessage">;
  }>;
  readonly threadState: GraphQLConversationThreadState;
  readonly " $fragmentType": "AlertResponderConversationWithRefetch_llmConversation";
};
export type AlertResponderConversationWithRefetch_llmConversation$key = {
  readonly " $data"?: AlertResponderConversationWithRefetch_llmConversation$data;
  readonly " $fragmentSpreads": FragmentRefs<"AlertResponderConversationWithRefetch_llmConversation">;
};

import AlertResponderConversationWithRefetchRefetchQuery_graphql from './AlertResponderConversationWithRefetchRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thinking",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thinkingSummary",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLMessageToolCall",
  "kind": "LinkedField",
  "name": "toolUse",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolUse",
      "kind": "LinkedField",
      "name": "toolUse",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "V2AgentThoughtProcessRenderer_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChecklistToolCallResult_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToolCallSheet_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SkillCluster_toolCall"
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": AlertResponderConversationWithRefetchRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "AlertResponderConversationWithRefetch_llmConversation",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "threadState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLFormattedMessage",
      "kind": "LinkedField",
      "name": "messages",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messageRole",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messageType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLAgentThoughtProcessItem",
          "kind": "LinkedField",
          "name": "agentThoughtProcess",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subagentDescription",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subagentOutput",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLAgentThoughtProcessItem",
              "kind": "LinkedField",
              "name": "subagentItems",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/)
              ],
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "messageWithToolReferences_formattedMessage"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLLlmConversation",
  "abstractKey": null
};
})();

(node as any).hash = "6ddfef65cedcfc90d1b7602274cd1a7d";

export default node;
